import { useRecoilValue } from 'recoil';

import type { EventSettingsGridType, EventSettingsGridKey } from '../../../entities/event-settings';
import { userEventSettings } from '../../../state/user';
import type { GridSettings } from '../../../types';

const gridSettingsKeyMap: Record<EventSettingsGridType, EventSettingsGridKey> = {
  incident: 'incidentGridSettings',
  drs: 'drsGridSettings',
  pmp: 'pmpGridSettings',
};

export const FONT_SIZE_MAP: Record<GridSettings['fontSize'], number> = {
  md: 1,
  lg: 1.4,
  xl: 1.8,
};

export const useGridScale = (gridType: EventSettingsGridType): number => {
  const userEventSetting = useRecoilValue(userEventSettings);

  return FONT_SIZE_MAP[userEventSetting[gridSettingsKeyMap[gridType]].fontSize];
};
